import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'
import Main from '@/views/Main.vue'

import { NConfigProvider, darkTheme } from 'naive-ui'
import { zhCN, dateZhCN } from 'naive-ui'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showTile = ref(false)
const mainStore = useMainStore(pinia)
//  -------------------------配置UI库主题

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_n_message_provider = _resolveComponent("n-message-provider")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    theme: _unref(darkTheme),
    locale: _unref(zhCN),
    "date-locale": _unref(dateZhCN)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_message_provider, null, {
        default: _withCtx(() => [
          _createVNode(_component_RouterView)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["theme", "locale", "date-locale"]))
}
}

})